<template>
  <td class="table--name">    
    <ObjectFit
      v-if="profileimage !== ''"
      :src="profileimage"
      :title="name"
      :alt="name"
    />

    <div
      v-else
      class="table--name--empty-image"
    >
      <p>{{ firstLettersOfName() }}</p>
    </div>

    <div class="table--name--text">
      <p class="table--name--text--name">
        <span v-if="isadmin === true">👑</span>
        
        {{ name }}
      </p>
      <p class="table--name--text--email">{{ email }}</p>
    </div>
  </td>
</template>

<script>
  import ObjectFit from '../../../components/images/objectFit.vue'
  
  export default {
    name: 'TdUser',
    components: {
      ObjectFit
    },
    props: [
      'profileimage',
      'name',
      'email',
      'isadmin'
    ],
    methods: {
      firstLettersOfName: function() {
        const matches = this.name.match(/\b(\w)/g);
        const joinMatches = matches.join('');

        return joinMatches;
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  .table {
    .table--name {

      %circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        float: left;
      }

      .object-fit-fallback-box {
        @extend %circle;
      }

      &--empty-image {
        @extend %circle;
        background-color: var(--blue);
        display: flex;
        justify-content: center;
        align-items: center;

        p {
          color: var(--white);
          font-weight: bold;
          font-size: 11px;
        }
      }

      &--text {
        float: left;
        margin-top: -2px;
        margin-left: 10px;

        p {
          display: block;
          line-height: 1.3em;
        }

        &--name {
          font-weight: bold;

          span {
            margin-right: 0;
          }
        }

        &--email {
          font-size: 11px;
          opacity: 0.5;
        }
      }
    }

    @include media-sm {

      .table--name {
        overflow: hidden;
        text-align: left;
      }
    }
  }
</style>
